'use strict';

const { getItem, STORAGE_KEYS } = require('public/js/lib/local-storage');

/**
 * True when a selected supplier is cached in localStorage (`rp:supplier:v1`).
 *
 * PMA manual pages render pricing MSRP-only server-side (cache-safe) and rely on this client-side
 * signal — never a per-page AJAX call — to decide whether the buyer already has a supplier.
 *
 * @returns {boolean}
 */
function hasSelectedSupplier() {
	const cached = getItem(STORAGE_KEYS.SUPPLIER_V1);

	return Boolean(cached && typeof cached === 'object' && cached.hash && cached.name);
}

/**
 * Toggles the PMA MSRP-only section (`.js-supplier-msrp-only`) based on the cached supplier.
 *
 * PMA manual pages render MSRP-only server-side (cache-safe). When a supplier is cached the buyer
 * should no longer see MSRP, so we suppress it with `.supplier-msrp-suppressed` (visibility:hidden)
 * which keeps the reserved height and avoids layout shift (CLS). The dealer-specific priced view is
 * rendered on reload. Safe to call repeatedly.
 *
 * @param {ParentNode} [scope=document]
 * @returns {void}
 */
function applyPmaMsrpVisibility(scope) {
	const root = scope || document;

	if (!root || typeof root.querySelectorAll !== 'function') {
		return;
	}

	const suppress = hasSelectedSupplier();
	const msrpEls = root.querySelectorAll('.js-supplier-msrp-only');

	for (let i = 0; i < msrpEls.length; i += 1) {
		if (suppress) {
			msrpEls[i].classList.add('supplier-msrp-suppressed');
		} else {
			msrpEls[i].classList.remove('supplier-msrp-suppressed');
		}
	}
}

module.exports = { applyPmaMsrpVisibility, hasSelectedSupplier };
